<section class="DatagridBody" #datagridBody>
  @if (!hasAnErrorOccurred) {
    <section role="rowgroup">
      @if (rows && !isLoading) {
        @if (rows.length > 0) {
          @for (
            row of config.rowLimit ? (rows | slice: 0 : config.rowLimit) : rows;
            track row;
            let rowIndex = $index
          ) {
            <section
              class="DatagridBody__row__wrapper"
              role="row"
              [attr.aria-rowindex]="rowIndex"
            >
              <div
                class="DatagridBody__row"
                [ngClass]="{ 'is-clickable': selectableRows }"
                [attr.data-test-id]="'datagridDataRow-' + rowIndex + dataGridId"
              >
                @if (config.isSelectable) {
                  <div
                    class="DatagridBody__cell DatagridBody__cell--select"
                    role="cell"
                  >
                    <icon
                      tabindex="0"
                      [name]="
                        isRowSelected(row) ? 'checkbox_active' : 'checkbox'
                      "
                      [config]="{
                        type: 'pointer',
                        fill: isRowSelected(row) ? 'primary' : 'initial',
                      }"
                      (click)="toggleRow($event, row)"
                      (keydown.space)="toggleRow($event, row)"
                    >
                    </icon>
                  </div>
                }
                @for (
                  column of config?.columns;
                  track column;
                  let columnIndex = $index
                ) {
                  <div
                    class="DatagridBody__cell"
                    [ngClass]="{
                      'DatagridBody__cell--ellipsis': column.width,
                      'DatagridBody__cell--alignRight': column.isRightAligned,
                      'DatagridBody__cell--alignLeft': column.isLeftAligned,
                      'DatagridBody__cell--alignCenter':
                        column.isCenterAligned ||
                        (!column.isLeftAligned && !column.isRightAligned),
                    }"
                    [ngStyle]="{
                      width: getColumnWidth(column),
                      'min-width': getColumnWidth(column),
                      'max-width': getColumnWidth(column),
                    }"
                    (click)="datagridRowClicked.emit(row)"
                    [attr.data-test-id]="
                      'datagridBodyDataColumn-' +
                      rowIndex +
                      dataGridId +
                      '.' +
                      columnIndex
                    "
                    role="cell"
                  >
                    <ng-template
                      [ngTemplateOutlet]="cellOptions"
                      [ngTemplateOutletContext]="{
                        row: row,
                        column: column,
                        index: rowIndex,
                      }"
                    >
                    </ng-template>
                    @if (column.tooltipProp) {
                      <tooltip
                        class="DatagridBody__Tooltip"
                        [config]="{
                          description: getFormattedToolTipValue(row, column),
                        }"
                      ></tooltip>
                    }
                  </div>
                }
              </div>
            </section>
          }
          <datagrid-summary-row [rows]="rows" [config]="config">
          </datagrid-summary-row>
        } @else {
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        }
      } @else {
        @defer {
          <div
            class="DatagridBody__loader"
            data-test-id="datagridBodyDataLoader"
          >
            <preloader size="medium"></preloader>
            <p>Loading data...</p>
          </div>
        }
      }
    </section>
  } @else {
    <ng-container *ngTemplateOutlet="error"></ng-container>
  }
</section>
